import { render, staticRenderFns } from "./MortgageApplicationChoiceItem.vue?vue&type=template&id=621e5599&scoped=true&"
import script from "./MortgageApplicationChoiceItem.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationChoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationChoiceItem.vue?vue&type=style&index=0&id=621e5599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e5599",
  null
  
)

export default component.exports